module.exports = __webpack_public_path__ + "static/media/rectangle.c05f82f2.svg";